import { CurrencyCostMapper } from '../impact';

export interface LocalCarbonRemovalProject {
  projectId: number;
  prices: CurrencyCostMapper;
}

export const UKBiocharProject: LocalCarbonRemovalProject = {
  projectId: 11228,
  prices: {
    GBP: 220,
    EUR: 280,
    USD: 325,
    CAD: 450,
    AUD: 485,
  },
};

export const localCarbonRemovalProjectIdMapper: {
  readonly [projectId: number]: LocalCarbonRemovalProject;
} = {
  11228: UKBiocharProject,
};
